import types from "../actionTypes";

export default (
  state = {
    myApplications: [],
    totalCount: 0
  },
  action
) => {
  switch (action.type) {
    case types.SET_MY_APPLICATIONS:
      return Object.assign({}, state, {
        myApplications: action.myApplications
      });
    case types.SET_MY_APPLICATIONS_TOTALCOUNT:
      return Object.assign({}, state, {
        totalCount: action.totalCount
      });
    default:
      return state;
  }
};
